// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"6513ae1c","403":"a6d73dab","453":"a7346c64","457":"877eb3d3","510":"a7e5ec4d","636":"fbc5de8d","752":"73ff0bff","780":"ed463461"}[chunkId] + ".chunk.js";
};